import GameParameterInterface from '@/models/game/parameters/interface'
import { Property } from '@/models/game/property'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'
import { ScriptLoader } from '@/util/scriptLoader'

export default class BarrelGameExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface
  ) { }

  async execute(): Promise<void> {

    const scriptLoader = new ScriptLoader({
      src : this.property.scriptUrl,
      global: 'GAME',
    })

    const game: any = await scriptLoader.load()

    game.setOption({
      ...this.parameter.createSetOption(),
      statusIsCompleted: this.processor.playStatusIsCompleted,
      resource: this.property.resourcePath,
      theme: `${this.processor.gameOrganizer}/${this.property.theme}`,
      nextPageUrl: this.processor.makeGameResultUrl(),
    })
    .setStarted(() => {

      if (!this.processor.playStatusIsStarted) {
        return this.processor.notifyGameStart({})
      }
    })
    .setCompleted(() => {

      return this.processor.notifyGameComplete()
    })
    .start()
  }
}
